// ТИПЫ ПЕРЕЛЁТА
export const FLIGHT_TYPES_NAME = {
  REGULAR: 'regular',
  BLOCK: 'block',
  CHARTER: 'charter',
  NA: 'n/a',
};

export const FLIGHT_TYPES = {
  [FLIGHT_TYPES_NAME.REGULAR]: {
    title: 'Регулярный рейс',
    description: 'Возможны доплаты',
    tooltip:
      'Регулярные рейсы отправляются по заранее утвержденному расписанию авиакомпании.\n\n Это значит, что ни аэропорты, ни время вылета, ни авиакомпании, ни номера рейсов уже не изменятся.\n\n При актуализации цены на тур стоимость тура может поменяться из-за добавления топливного сбора или из-за того, что остались билеты только по дорогому тарифу.',
  },
  [FLIGHT_TYPES_NAME.BLOCK]: {
    title: 'Чартерные места на регулярном рейсе',
    description: 'Возможны изменения рейса',
    tooltip:
      'Туроператоры часто выкупают места на регулярных рейсах и работают с ними, как с чартерами.\n\n Покупая тур с такими местами, нужно быть готовым, что туроператор может их перенести.\n\n Каким именно рейсом вы полетите, во сколько и откуда — будет известно примерно за 12 часов до вылета. О любых изменениях мы сразу сообщим вам по SMS или e-mail.',
  },
  [FLIGHT_TYPES_NAME.CHARTER]: {
    title: 'Чартерный рейс',
    description: 'Возможны изменения рейса',
    tooltip:
      'Особенность чартерного рейса в том, что аэропорты, номера рейсов, авиакомпания или время вылета могут измениться в пределах суток.\n\n Если это случится, мы сообщим вам по SMS или e-mail. Обо всех изменениях будет известно за 12 часов до вылета или раньше.',
  },
  [FLIGHT_TYPES_NAME.NA]: {
    title: 'Тип рейса не определен',
  },
};

// КЛАСС ПЕРЕЛЁТА
export const FLIGHT_CLASSES = {
  ECONOMY: 'economy',
  BUSINESS: 'business',
};

export const FLIGHT_CLASSES_NAME = {
  [FLIGHT_CLASSES.ECONOMY]: 'эконом',
  [FLIGHT_CLASSES.BUSINESS]: 'бизнес',
};
